import {observer} from "mobx-react";
import React, {useState} from "react";
import {callWithCatch, tourneyUrl} from "../../utils";
import {Button, Form, Input, Space} from "antd";

export default observer(({coupon, setCoupon, form, extraParams}) => {
  const [couponLoading, setCouponLoading] = useState();

  const couponName = Form.useWatch('coupon', form);

  let applyCoupon = async () => {
    let url = tourneyUrl("/coupons/" + couponName + "/check");
    if (extraParams) {
      let qs = new URLSearchParams(extraParams).toString();
      url += (url.includes('?') ? '&' : '?') + qs;
    }
    await callWithCatch({
      url,
      method: 'get',
      setLoading: setCouponLoading,
      onSuccess: data => {
        if (data.coupon)
          setCoupon(data.coupon);
      }
    });
  }

  return <Form.Item label="Coupon Code" name="coupon">
    <Space>
      <Input suffix={<div className="text-green-600">{coupon?.effect}</div>}/>
      {!coupon && <Button loading={couponLoading} onClick={applyCoupon}>Apply</Button>}
    </Space>
  </Form.Item>

});